import { action, computed, observable } from 'mobx';

import { ViewController } from '@estee/elc-service';

import { IPasswordCriteria, IPasswordCriteriaItem } from '~domain/entities/Config';
import { PasswordRepository } from '~repositories/PasswordRepository';
import { TranslationRepository } from '~repositories/TranslationRepository';

interface IPasswordCriteriaItemProp extends IPasswordCriteriaItem {
    isMatched: boolean;
}

interface IPasswordCriteriaViewController {
    passwordRepository: PasswordRepository;
    translationRepository: TranslationRepository;
}

export class PasswordCriteriaViewController extends ViewController {
    @observable private passwordCriteriaProps: IPasswordCriteria;
    private passwordCriteriaItems: IPasswordCriteriaItemProp[];
    private passwordRepository: PasswordRepository;
    private translationRepository: TranslationRepository;

    constructor({ passwordRepository, translationRepository }: IPasswordCriteriaViewController) {
        super();
        this.passwordRepository = passwordRepository;
        this.translationRepository = translationRepository;
    }

    @action
    public loaded = async (props: IPasswordCriteria) => {
        this.passwordCriteriaProps = props;
        this.passwordCriteriaItems = props.items.map((item) => {
            return {
                ...item,
                inputLabel: this.translationRepository.translations[item.labelKey],
                isMatched: false
            };
        });
    };

    @computed
    public get data() {
        const { passwordDataStore } = this.passwordRepository;
        const passwordValue = passwordDataStore[this.passwordCriteriaProps.passwordFieldName];
        const criteriaData = this.getPasswordCriteriaItems(passwordValue);

        return {
            criteriaData,
            isShown: passwordValue ? true : false
        };
    }

    @action
    private getPasswordCriteriaItems = (inputtedPassword: string) => {
        const criteriaData = this.passwordCriteriaItems;
        if (inputtedPassword) {
            this.passwordCriteriaProps.items.forEach((item, idx) => {
                const rule = new RegExp(item.pattern);
                const isMatched = rule.test(inputtedPassword);
                const matchedStatus = isMatched ? true : false;
                Object.assign(criteriaData[idx], { isMatched: matchedStatus });
            });
        }

        return criteriaData;
    };
}
